const apiName = process.env.BUILD_ENV === 'dev' ? 'ec-pc-api' : 'ec-pc-api'
// SPU API
const spu = {
  listSpu: {
    type: 'post',
    url: `${apiName}/spu/list`
  },
  exportSpu: {
    type: 'get',
    url: `${apiName}/spu/export`
  },
  addSpuInfo: {
    type: 'post',
    url: `${apiName}/spu/save`
  },
  updateSpuInfo: {
    type: 'post',
    url: `${apiName}/spu/update`
  },
  unbindSku: {
    type: 'post',
    url: `${apiName}/spu/unbind`
  },
  getSkuBySpuId: {
    type: 'post',
    url: `${apiName}/spu/goods/all/list`
  },
  listGoods: {
    type: 'post',
    url: `${apiName}/spu/goods/list`
  },
  removeSky: {
    type: 'post',
    url: `${apiName}/spu/removesku`
  },
  exportExcels: {
    type: 'post',
    url: `${apiName}/spu/export`
  }


};

export default spu;
